import { render, staticRenderFns } from "./ComplaintSummary.vue?vue&type=template&id=d017b300&scoped=true&"
import script from "./ComplaintSummary.vue?vue&type=script&lang=js&"
export * from "./ComplaintSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d017b300",
  null
  
)

export default component.exports